var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.600586,
    y: 0.481201,
    width: 60.3237,
    height: 60.3237,
    rx: 16,
    fill: "#E2EEEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3801 19.9418L37.226 21.2362L40.8166 27.2209V35.6699H39.5598V33.1565C39.5598 32.4898 39.295 31.8505 38.8236 31.3792C38.3523 30.9078 37.7129 30.643 37.0463 30.643H35.7896V19.3323H20.7086V39.4402H19.4519V41.9537H37.0463V39.4402H35.7896V33.1565H37.0463V35.6699C37.0463 36.3366 37.3111 36.9759 37.7825 37.4473C38.2539 37.9186 38.8932 38.1834 39.5598 38.1834H40.8166C41.4832 38.1834 42.1225 37.9186 42.5939 37.4473C43.0652 36.9759 43.33 36.3366 43.33 35.6699V26.5246L39.3801 19.9418ZM33.2761 39.4402H23.2221V26.8727H33.2761V39.4402ZM33.2761 24.3593H23.2221V21.8458H33.2761V24.3593Z",
    fill: "#1D1D35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.249 38.1835C29.2332 38.1348 30.1641 37.7219 30.8609 37.0251C31.5577 36.3284 31.9705 35.3974 32.0192 34.4132C32.0192 32.8096 30.0084 30.6204 29.1375 29.7545L28.249 28.866L27.3605 29.7545C26.4896 30.6204 24.4788 32.8096 24.4788 34.4132C24.5274 35.3974 24.9403 36.3284 25.6371 37.0251C26.3339 37.7219 27.2648 38.1348 28.249 38.1835ZM28.249 32.503C28.7805 33.058 29.2064 33.7054 29.5057 34.4132C29.4623 34.7312 29.3159 35.0263 29.089 35.2532C28.862 35.4801 28.567 35.6265 28.249 35.67C27.9343 35.6273 27.6418 35.4839 27.4153 35.2612C27.1888 35.0385 27.0404 34.7486 26.9922 34.4346C27.2873 33.7181 27.7135 33.063 28.249 32.503Z",
    fill: "#1D1D35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityIcon);
export default __webpack_public_path__ + "static/media/quality_icon.2fb5ca34063812d21c027b976ffd4f85.svg";
export { ForwardRef as ReactComponent };